import { Text } from '@mantine/core';
import * as React from 'react';

import { DocumentSearchItem } from '@/entities/DocumentsSearch';

type Props = {
  item: DocumentSearchItem;
};

const Quote: React.FC<Props> = ({ item }) => {
  return (
    <Text lineClamp={1} size="xxs" lh="xxs" c="blue">
      {item.quote}
    </Text>
  );
};

export default React.memo(Quote);
